export default async function fileReader(blob: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = resolve
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}
